import { lazy, Suspense } from "react";
import { Helmet } from "react-helmet-async";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import TrustBanner from "@/components/TrustBanner";
import FloatingCTA from "@/components/FloatingCTA";

const ServicesSection = lazy(() => import("@/components/ServicesSection"));
const MidPageCTA = lazy(() => import("@/components/MidPageCTA"));
const BeforeAfterSection = lazy(() => import("@/components/BeforeAfterSection"));
const GallerySection = lazy(() => import("@/components/GallerySection"));
const TestimonialsSection = lazy(() => import("@/components/TestimonialsSection"));
const WhyUsSection = lazy(() => import("@/components/WhyUsSection"));
const PartnersSection = lazy(() => import("@/components/PartnersSection"));
const ZoneSection = lazy(() => import("@/components/ZoneSection"));
const ContactSection = lazy(() => import("@/components/ContactSection"));
const FooterSection = lazy(() => import("@/components/FooterSection"));

const Index = () => {
  return (
    <div className="min-h-screen">
      <Helmet>
        <title>Habitat Prestige 89 – Peinture &amp; Rénovation à Sens (89)</title>
        <meta name="description" content="Artisan peinture, démoussage toiture, hydrofuge façade et petite maçonnerie à Sens (89) et 35 km autour. Devis gratuit sous 24h. ☎ 03 73 61 02 42" />
        <link rel="canonical" href="https://habitatprestige89.com/" />
        <meta property="og:title" content="Habitat Prestige 89 – Peinture & Rénovation à Sens (89)" />
        <meta property="og:description" content="Artisan peinture, démoussage toiture, hydrofuge façade et petite maçonnerie à Sens (89) et 35 km autour. Devis gratuit sous 24h. ☎ 03 73 61 02 42" />
        <meta property="og:url" content="https://habitatprestige89.com/" />
      </Helmet>
      <Header />
      <HeroSection />
      <TrustBanner />
      <Suspense fallback={<div className="min-h-[200px]" />}>
        <ServicesSection />
        <MidPageCTA />
        <BeforeAfterSection />
        <GallerySection />
        <TestimonialsSection />
        <WhyUsSection />
        <PartnersSection />
        <ZoneSection />
        <ContactSection />
        <FooterSection />
      </Suspense>
      <FloatingCTA />
    </div>
  );
};

export default Index;
